import React from "react"
import { Link, useNavigate } from "react-router-dom"
import { LogOut, Menu, X } from "lucide-react"
import { useAuth } from "../context/AuthContext"
import { useSidebar } from "../context/SidebarContext"
import DealerGroupSwitcher from "./DealerGroupSwitcher"
import { THEME } from "../config/theme"

const MOBILE_BREAKPOINT = 768

const TopBar: React.FC = () => {
  const { user, logout } = useAuth()
  const { isCollapsed, toggle } = useSidebar()
  const navigate = useNavigate()

  const isMobile =
    typeof window !== "undefined" && window.innerWidth < MOBILE_BREAKPOINT

  const handleLogout = () => {
    logout()
    navigate("/login")
  }

  const SidebarIcon = isCollapsed ? Menu : X

  return (
    <div
      style={{
        height: "48px",
        background: THEME.colors.brandGradient,
        color: THEME.colors.neutral.dark.textPrimary,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: isMobile ? "0 12px" : "0 24px",
        gap: isMobile ? "8px" : "0",
        position: "sticky",
        top: 0,
        zIndex: 100,
        fontFamily: THEME.fonts.primary,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: THEME.spacing.md }}>
        <button
          onClick={toggle}
          style={{
            background: "none",
            border: "none",
            color: THEME.colors.neutral.dark.textPrimary,
            cursor: "pointer",
            padding: "4px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <SidebarIcon size={22} />
        </button>
        <Link
          to="/dashboard"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
          aria-label="INVI Auto home"
        >
          <img
            src="/wordmark-on-dark.png"
            alt="INVI Auto"
            style={{ height: 15, display: "block" }}
          />
        </Link>
      </div>

      {/* The audit freshness timestamps that sat centered here were removed
          2026-09-14 (Ian) — the audit page's own run strip already carries
          that reading, and the banner copy was one more date to reconcile. */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: isMobile ? "8px" : "12px",
          minWidth: 0,
        }}
      >
        <DealerGroupSwitcher compact={isMobile} />
        {!isMobile && (
          <span
            style={{
              fontSize: "13px",
              color: THEME.colors.neutral.dark.textSecondary,
            }}
          >
            Hi, {user?.username ?? ""}
          </span>
        )}
        <button
          onClick={handleLogout}
          aria-label="Logout"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            background: "rgba(255, 255, 255, 0.08)",
            color: THEME.colors.neutral.dark.textPrimary,
            border: "0.5px solid rgba(255, 255, 255, 0.18)",
            borderRadius: THEME.borderRadius.md,
            // Icon-only on mobile to claw back horizontal space.
            padding: isMobile ? "6px 8px" : "5px 14px",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: 500,
            fontFamily: THEME.fonts.primary,
            flexShrink: 0,
            transition: "background-color 120ms ease, border-color 120ms ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.16)"
            e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.32)"
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)"
            e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.18)"
          }}
        >
          <LogOut size={14} strokeWidth={1.75} />
          {!isMobile && "Logout"}
        </button>
      </div>
    </div>
  )
}

export default TopBar
